import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaPhoneAlt, FaHeadset } from 'react-icons/fa';
import { motion } from 'framer-motion';

export default function ForgotPassword() {
    return (
        <div className="min-h-screen relative flex items-center justify-center overflow-hidden bg-[#0a0a0a] font-inter">
            {/* Animated Background Elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <motion.div
                    animate={{
                        x: [0, 80, 0],
                        y: [0, -40, 0],
                        scale: [1, 1.1, 1],
                    }}
                    transition={{
                        duration: 12,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                    className="absolute top-1/4 -right-20 w-[500px] h-[500px] bg-blue-600/10 rounded-full blur-[120px]"
                />

                {/* Technical Grid */}
                <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_at_center,black,transparent:80%)]"></div>
            </div>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                className="relative w-full max-w-md p-8 bg-white/5 backdrop-blur-2xl rounded-[32px] border border-white/10 shadow-2xl m-4"
            >
                <Link to="/login" className="inline-flex items-center gap-2 text-sm font-bold text-gray-400 hover:text-white mb-10 transition-colors group">
                    <motion.span
                        whileHover={{ x: -4 }}
                        transition={{ type: "spring", stiffness: 400, damping: 10 }}
                    >
                        <FaArrowLeft />
                    </motion.span>
                    Back to Login
                </Link>

                <div className="text-center mb-10">
                    <motion.div
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ type: "spring", stiffness: 200, damping: 15, delay: 0.2 }}
                        className="w-20 h-20 bg-gradient-to-br from-blue-500/20 to-blue-700/20 rounded-3xl flex items-center justify-center mx-auto mb-6 border border-blue-500/30 ring-8 ring-blue-500/5"
                    >
                        <FaHeadset className="text-blue-400 text-3xl" />
                    </motion.div>
                    <h2 className="text-3xl font-bold text-white tracking-tight mb-3">Password Help</h2>
                    <p className="text-gray-400 text-sm font-medium">
                        Please contact our support team to verify your identity and reset your password.
                    </p>
                </div>

                <div className="space-y-4">
                    <motion.div
                        whileHover={{ y: -2, backgroundColor: "rgba(255,255,255,0.08)" }}
                        className="bg-white/5 p-5 rounded-2xl border border-white/5 flex items-center gap-5 transition-all"
                    >
                        <div className="bg-blue-600/20 p-4 rounded-xl text-blue-400 border border-blue-600/20">
                            <FaPhoneAlt size={20} />
                        </div>
                        <div>
                            <p className="text-[10px] text-blue-400 font-bold uppercase tracking-widest mb-1">Main Hotline</p>
                            <p className="text-xl font-bold text-white tracking-wide">071 433 6294</p>
                        </div>
                    </motion.div>

                    <motion.div
                        whileHover={{ y: -2, backgroundColor: "rgba(255,255,255,0.08)" }}
                        className="bg-white/5 p-5 rounded-2xl border border-white/5 flex items-center gap-5 transition-all"
                    >
                        <div className="bg-blue-600/20 p-4 rounded-xl text-blue-400 border border-blue-600/20">
                            <FaHeadset size={20} />
                        </div>
                        <div>
                            <p className="text-[10px] text-blue-400 font-bold uppercase tracking-widest mb-1">Technical Support</p>
                            <p className="text-xl font-bold text-white tracking-wide">076 8582 057</p>
                        </div>
                    </motion.div>
                </div>

                <div className="mt-10 text-center">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/5 rounded-full">
                        <span className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse"></span>
                        <p className="text-xs text-gray-500 font-medium">
                            Support Available Mon - Sun: 8 AM - 8 PM
                        </p>
                    </div>
                </div>
            </motion.div>
        </div>
    );
}
